var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgilityLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 903,
    height: 135,
    viewBox: "0 0 903 135",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2149_15856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.86 133.871L204.7 105.591H163.962L151.357 132.541H120.123L185.667 1.88184H218.439L241.128 128.2L208.86 133.871ZM195.045 36.5854L175.155 80.498H201.272L195.045 36.5854Z",
    fill: "#55585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.376 122.855C354.052 130.849 338.792 135.082 323.235 135.101C288.95 135.101 268.127 114.349 268.127 80.2474C268.127 34.6034 298.378 0.100576 339.142 0.100576C353.145 -0.278993 367.001 3.03677 379.3 9.71117L370.78 36.8617C361.789 30.2487 350.901 26.6861 339.722 26.6991C316.226 26.6991 300.874 49.2827 300.874 78.7167C300.874 100.021 311.311 109.832 326.26 109.832C332.067 109.983 337.812 108.616 342.923 105.867L346.528 81.753H326.361V57.8896H378.443L367.376 122.855Z",
    fill: "#55585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.408 132.541H402.468L423.039 2.40869H455.055L434.408 132.541Z",
    fill: "#55585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.23 132.541L493.877 2.40869H525.994L509.608 105.29H549.01V132.541H473.23Z",
    fill: "#55585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.748 132.541H578.732L599.378 2.40869H631.394L610.748 132.541Z",
    fill: "#55585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.77 28.6559L708.283 132.541H676.468L692.754 28.6559H657.461L661.696 2.40869H762.256V28.6559H724.77Z",
    fill: "#55585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.018 84.8391L837.456 132.516H805.263L812.826 85.3912L782.575 6.39861L816.103 1.104L834.481 54.2759L868.514 2.40884H903L845.018 84.8391Z",
    fill: "#55585A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7642 0H156.374L0 62.105L16.7642 0Z",
    fill: "#DC4405"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2149_15856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 903,
    height: 135,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgilityLogo);
export default __webpack_public_path__ + "static/media/agility-logo.6a6c92c6cafb32ea2e52a5cece01d15e.svg";
export { ForwardRef as ReactComponent };